import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute } from '@angular/router'; //, Params

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

@Component({
  selector: 'app-tex-detail',
  templateUrl: './tex-detail.component.html',
  styleUrls: ['./tex-detail.component.css']
})
export class TexDetailComponent implements OnInit {

  warehouseId:any;
  taxdata:any = []; 
  payment_method = '';
  constructor(
    public bp: BasicProvider,
    public up: UserProvider,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { 
    this.warehouseId = this.activatedRoute.snapshot.params['warehouseId'];
    if( this.warehouseId!='' && this.warehouseId != undefined ) {
      this.getPackageTaxDetail();
    }
    
  }

  ngOnInit() {
  }


  getPackageTaxDetail(){
    let api = 'warehouse/tax_details';
    let searchFilter = {
      warehouseId: this.warehouseId
    };
    
    this.bp.hitApi(api, 'POST', searchFilter, true, true)
    .subscribe(
      (success) => { 
        console.log(success);
        if ( success.type == true ) { 
          this.taxdata = success.data;
        } else {
          this.bp.show_toast('Error',success.message);
        }
      }, 
      (error) => {
        console.log(error);
      }
    );
    
  }

  redirectToPage(){
    if (this.payment_method == '') {
      this.bp.show_toast('Error','Please select payment method.');
      return false;
    } else {
      if (this.payment_method == 'COD') {
        this.payCOD();
      } else {
        /*window.open(this.bp.webUrl+'webpay/dashexpress_payment.php?action=payment&w='+this.warehouseId, 
        'DashexpressPayment', 
        'toolbar=no,scrollbars=yes,resizable=no,top=100,left=500,width=600,height=400,location=0');*/

        
        window.open(this.bp.webUrl+'webpay/dashexpress_card_payment.php?action=show_card&w='+this.warehouseId, 
        'DashexpressPayment', 
        'toolbar=no,scrollbars=yes,resizable=no,top=100,left=500,width=600,height=400,location=0'); 

        //alert(this.payment_method);
        //this.router.navigate(['addcard']);
        //this.up.tempWarehouseId = this.warehouseId;
        //this.router.navigate(['addcard',this.warehouseId]);
      }
    }
  }

  backToList(){
    //this.navCtrl.setRoot('WelcomePage',{},{ animate: true, direction: 'back' });
  } 
  
  payCOD(){
    let api = 'warehouse/payment_confirm';
    let searchFilter = {
      warehouseId: this.warehouseId,
      payment_method: this.payment_method
    };
  
    this.bp.hitApi(api, 'POST', searchFilter, true, true)
    .subscribe(
      (success) => { 
        console.log(success);
        if ( success.type == true ) { 
          this.router.navigate(['mypackage']);
          this.bp.show_toast('Success',success.message);
        } else { 
          this.bp.show_toast('Error',success.message);
        }
      }, 
      (error) => {
        console.log(error);
      }
    );
    
  }

}



// WEBPACK FOOTER //
// ./src/app/tex-detail/tex-detail.component.ts